import React from 'react'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import { MeetingTypeList } from '../../components/meeting-types/MeetingTypes'
import useTranslation from '../../../utils/translation'
import MeetingTypeItem from '../../components/meeting-type-selection/MeetingTypeItem'

const Heading = styled.h2`
  font-family: ${theme('amend.step2.meetingTypes.heading.fontFamily')};
  font-size: ${theme('amend.step2.meetingTypes.heading.fontSize.mobile')};
  font-weight: ${theme('amend.step2.meetingTypes.heading.fontWeight')};

  ${(props) => props.theme.media.min.sm`
    font-size: ${theme('amend.step2.meetingTypes.heading.fontSize.desktop')};
  `}
`
/* eslint-disable no-unused-vars */
const MeetingTypes = ({ meetingTypes, selectedMeetingType, onChange }) => {
  const t = useTranslation('amend.step2.meetingType')
  return (
    <>
      <Heading>{t('heading')}</Heading>
      <MeetingTypeList>
        {meetingTypes &&
          meetingTypes.map(
            ({
              id,
              icon,
              serviceCode,
              heading,
              descriptionMobile,
              duration,
            }) => (
              <MeetingTypeItem
                key={`${id}-${serviceCode}`}
                name="MeetingType"
                value={id.toString()}
                checked={selectedMeetingType.id === id}
                onChange={() => onChange(id)}
                props={{
                  id: serviceCode,
                  name: heading,
                  text: descriptionMobile,
                  icon,
                  checked: selectedMeetingType.id === id,
                  serviceId: id,
                  serviceCode,
                  serviceDuration: duration,
                }}
              />
            )
          )}
      </MeetingTypeList>
    </>
  )
}

export default MeetingTypes
